module.exports = __webpack_public_path__ + "img/leaf-oak.27650861.svg";